import idx from "idx"

/**
 * transform - manipulate data for tech specs
 * @param {object} people - boardofdirectors query
 * @returns {object}
 */

function transform(boardOfDirectors) {
  const people = boardOfDirectors
    ? boardOfDirectors.map(person => {
        return {
          id: idx(person, _ => _.id),
          name: idx(person, _ => _.name),
          titlesOrganizations: idx(person, _ => _.titlesOrganizations.titlesOrganizations)
        }
      })
    : []
  return {
    people
  }
}

export default { transform }
